import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, queryClient, QueryConfig } from 'lib/react-query';

import { Snapshot } from 'types';

export const getSnapshot = async (
  snapshotId: number
): Promise<Snapshot | undefined> => {
  if (snapshotId < 1) return;
  const { data } = await axios.get(`/api/snapshots/${snapshotId}`);
  return data as Snapshot;
};

export const getInitialData = (
  analyzerId: number | undefined,
  snapshotId: number
) => {
  if (!analyzerId) return;

  const snapshots: Snapshot[] | undefined = queryClient.getQueryData([
    'snapshots',
    analyzerId,
  ]);

  return snapshots?.find((snapshot) => snapshot.id === snapshotId);
};

type QueryFnType = typeof getSnapshot;

type UseSnapshotOptions = {
  snapshotId: number;
  analyzerId?: number;
  config?: QueryConfig<QueryFnType>;
};

export const useSnapshot = ({
  snapshotId,
  analyzerId,
  config,
}: UseSnapshotOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    initialData: getInitialData(analyzerId, snapshotId),
    queryKey: ['snapshot', snapshotId],
    queryFn: () => getSnapshot(snapshotId),
  });
};
